// extracted by mini-css-extract-plugin
export default {"addLayerButtonWrapper":"ButtonAddLayer_addLayerButtonWrapper__XhDpM","dropDown":"ButtonAddLayer_dropDown__RFpCu","addLayerButton":"ButtonAddLayer_addLayerButton__rBt8W"};